import React, { useState } from 'react';
import { Table, Button, Typography, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { compose } from '@reduxjs/toolkit';
import { isNull } from 'lodash';
import { BarChartOutlined } from '@ant-design/icons';
import DialogUnbindUser from '../Dialogs/DialogsUnbinUser';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';

const { Link, Text } = Typography;

const UserTable = ({ items, depotCode, refetch }) => {
  const [users, setUsers] = useState(null);
  const [openUnbin, setOpenUnbin] = useState(false);
  const { t } = useTranslation(['admin']);

  const handleOpenDialogUnbindUser = (record) => {
    setUsers(record);
    setOpenUnbin(true);
  };

  const getColumns = () => [
    {
      title: 'Mã khách hàng',
      dataIndex: 'userId',
      key: 'userId'
    },
    {
      title: 'Tài khoản',
      dataIndex: 'userName',
      key: 'userName'
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: '',
      key: 'unbind',
      render: (text, record) => (
        <Link onClick={() => handleOpenDialogUnbindUser(record)}>
          <DeleteOutlinedIcon style={{ color: '#52525B' }} />
        </Link>
      )
    }
  ];

  return (
    <>
      <DialogUnbindUser
        depotCode={depotCode}
        users={users}
        openUnbin={openUnbin}
        setOpenUnbin={setOpenUnbin}
        refetch={refetch}
      />
      <div style={{ width: '100%', overflow: 'auto', marginTop: '10px' }}>
        <Table
          style={{ marginTop: '10px' }}
          columns={getColumns()}
          dataSource={items || []}
          rowKey="userId"
          pagination={false}
        />
      </div>
    </>
  );
};

export default compose(withPaginate)(UserTable);
